module.exports = __webpack_public_path__ + "img/en.ea393f9b.png";